module.exports = __webpack_public_path__ + "static/Science-Graphic@3x-3c3ac47be62b71e21243c5703e9df74e.png";